<script>
export default {
  props: {
    title: { type: String, required: true },
    description: { type: String, default: '' },
    lightImage: { type: String, default: '' },
    darkImage: { type: String, default: '' },
    active: { type: Boolean, default: false },
  },
};
</script>

<template>
  <div class="flex items-center gap-3 p-3">
    <img
      v-if="lightImage || darkImage"
      :src="lightImage || darkImage"
      :alt="title"
      class="w-10 h-10 object-contain"
    />
    <div>
      <p class="text-sm font-medium">{{ title }}</p>
      <p v-if="description" class="text-xs text-n-slate-11">
        {{ description }}
      </p>
    </div>
  </div>
</template>
